module.exports = __webpack_public_path__ + "img/5-3.354a5201.svg";